export const formatCurrency = (value,currency = 'EUR') => {
    return new Intl.NumberFormat('en-US', {
      currency: currency || 'INR',
    }).format(value);
  };